export default {
      id: "clock-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }